
export enum TipoFeriadoEnum {
  Nacional = 'Nacional',
  Estadual = 'Estadual',
  Municipal = 'Municipal',
}
